mp.langswitch = {
    init: function () {
        $(document).on('change', '#mpLangSelect', mp.langswitch.submitTopLangswitch);
        $(document).on('click', '#mpLangSelect', function(ev) { ev.stopPropagation(); });

        if (!mp.isBot()) {
            $(document).on('click', '#mpLangList a', mp.langswitch.footerLink);
        }

        if (window.location.search.match(/mpi/) || window.location.search.match(/mpn/)) {
            mp.langswitch.cleanSessionGetParams();
        }
    },

    submitTopLangswitch: function () {
        $('#mpTopLangswitch').trigger('submit');
    },

    footerLink: function (ev) {
        ev.preventDefault();
        $('#mpLangSelect').val($(this).attr('href')).trigger('change');
        return false;
    },

    cleanSessionGetParams: function () {
        try {
            var searchParams = new URLSearchParams(window.location.search);
            var newLocation = window.location.pathname;
            searchParams.delete('mpi');
            searchParams.delete('mpn');
            if (searchParams.toString() !== '') {
                newLocation += '?' + searchParams.toString();
            }
            window.history.replaceState({}, document.title, newLocation);
        } catch (e) {
            /* nicht schlimm, wenn das nicht klappt! */
        }
    }
};

$(document).ready(function () {
    mp.langswitch.init();
});